import { apiClient } from "@/lib/api-client";
import type { IdentityQuery, IdentityRequest } from "@/lib/identity-contract";

import type {
  UpdatedUserStatus,
  UpdateUserStatusResponse,
  UserListResponse,
  UserListResult,
  UserStatus,
} from "./types";

export type ListUsersParams = NonNullable<IdentityQuery<"listUsers">>;

export async function listUsers(params: ListUsersParams = {}): Promise<UserListResult> {
  const query = new URLSearchParams();
  if (params.status) query.set("status", params.status);
  if (params.limit !== undefined) query.set("limit", String(params.limit));
  if (params.offset !== undefined) query.set("offset", String(params.offset));
  const suffix = query.toString();
  const path = suffix ? `/identity/users?${suffix}` : "/identity/users";

  const response = await apiClient.get<UserListResponse>(path);
  return { users: response.data, total: response.meta.total };
}

export async function updateUserStatus(id: string, status: UserStatus): Promise<UpdatedUserStatus> {
  const body: IdentityRequest<"setUserStatus"> = { access_status: status };
  const response = await apiClient.patch<UpdateUserStatusResponse>(
    `/identity/users/${id}/status`,
    body
  );
  return response.data;
}
